/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuicksightData } from '../../models/quicksight-data';

export interface GetQuicksightData$Params {
}

export function getQuicksightData(http: HttpClient, rootUrl: string, params?: GetQuicksightData$Params, context?: HttpContext): Observable<StrictHttpResponse<QuicksightData>> {
  const rb = new RequestBuilder(rootUrl, getQuicksightData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuicksightData>;
    })
  );
}

getQuicksightData.PATH = '/api/quicksight/info';
